import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import _ from 'lodash';
import MobileHeader from 'components/MobileHeader/index';
import Loader from 'components/common/Loader';
import SidebarHeader from 'components/SidebarHeader';
import APILoader from 'components/common/APILoader';
import Header from 'components/common/Header';
import { pageDetails } from 'constants/Common';

class MainApp extends Component {
  state = {
    currentPageDetails: '',
    visible: false,
    isDeviceUrl: false,
    HeaderStripList: true,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  UNSAFE_componentWillMount() {
    const currentPage = _.first(_.without(window.location.pathname.split('/'), ''));
    const currentPageDetails = _.find(pageDetails, {
      url: '/' + currentPage,
    });

    this.setState({
      currentPageDetails: currentPageDetails,
    });
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };
  HeaderStripCick = () => {
    this.setState({
      HeaderStripList: !this.state.HeaderStripList,
    });
  };

  render() {
    if (window.drift) {
      window.drift.on('campaign:dismiss', (data) => {});

      if (window.drift && window.drift.api) {
        window.drift.api.widget.hide();
      }
    }

    const isMobile = window.innerWidth <= 767;
    const { loading } = this.props;

    return (
      <>
        {/* <OnlineChat/> */}
        <div className={`d-flex flex-wrap pageWrapperBlock ${this.state.HeaderStripList && 'active'}`}>
          {loading && <Loader loading={loading} fixed />}
          <APILoader />
          {isMobile ? <MobileHeader /> : <SidebarHeader />}

          <div className="content-area pageHeight without-footer">
            {isMobile ? null : <Header />}
            {this.props.children}
          </div>
          {/* {setFooterData()} */}
          {_.first(_.without(window.location.pathname.split('/'), '')) !== 'diamond-search' &&
            _.first(_.without(window.location.pathname.split('/'), '')) !== 'fancy-search' &&
            this.props.commonData.pagePermission().quickSearch &&
            this.props.commonData.pagePermission().quickSearch.view && <div></div>}
        </div>
      </>
    );
  }
}

const mapStateToProps = function ({ loading, commonData }) {
  return { loading, commonData };
};

export default connect(mapStateToProps)(withRouter(MainApp));
